import { inject, Injectable } from '@angular/core';
import { RestClient } from '@extensions/rest.client';
import { INotification } from '@interfaces/notification';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { IRequestOptions } from '@interfaces/request-options';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends BaseService {
  private restClient = inject(RestClient);

  constructor() {
    super();
  }

  public getNotifications(): Observable<INotification[]> {
    const requestOptions = {
      headers: new HttpHeaders({
        'x-perm': 'GetList'
      })
    } as IRequestOptions;

    return this.restClient.Get<INotification[]>('api/notification', requestOptions);
  }

  public saveNotification(notification: INotification): Observable<INotification> {
    const permission = (notification.id && notification.id !== '') ? 'Update' : 'Create';

    const requestOptions = {
      headers: new HttpHeaders({
        'x-perm': permission
      })
    } as IRequestOptions;

    return permission === 'Update'
      ? this.restClient.Put<INotification>('api/notification', notification, requestOptions)
      : this.restClient.Post<INotification>('api/notification', notification, requestOptions);
  }
}
